const INITIAL_STATE = {
    partnersRaw: [],
    recruiterId: 0,
    sectionActive: "Control",
    clientId: 0,
    ceco: 0
};

const partnerReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'SET_PARTNERS':
            return {
                ...state,
                partnersRaw: action.payload
            };
        case 'SET_RECRUITER':
            return {
                ...state,
                recruiterId: action.payload
            };
        case 'SET_SECTION':
            return {
                ...state,
                sectionActive: action.payload
            };
        case 'SET_CLIENT':
            return {
                ...state,
                clientId: action.payload
            }
        case 'SET_CECO':
            return {
                ...state,
                ceco: action.payload
            }
        default:
            return state;
    }
};

export default partnerReducer;


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/reducers/partnerReducer.js